
import { defineComponent } from "vue";
import { dateFormatDate } from "@/utils/date.utils";
import { TrainingData, TrainingDataModification } from "@/types/trainingData.type";
import {
  getvisualizeTrainingData,
  postTrainingData,
  postTrainingDataModification,
} from "@/service/trainingData.service";
import ElMessage from "element-plus/lib/components/message";
import { getUserById } from "@/service/user.service";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import { Filter } from "@/types/filter.type";

export default defineComponent({
  props: {
    entities: {
      type: Object as () => TrainingData[],
    },
  },
  setup() {
    return { dateFormatDate };
  },
  data() {
    return {
      rowPerPage: 10 as number,
      totalRows: 0 as number | undefined,
      currentPage: 1 as number,
      skip: 0,
      data: [] as TrainingData[],
      count: 0,
      container: "" as string | undefined,
      origin: "" as string,
      isModalVisible: false,
      allParams: false,
      editForm: {} as TrainingData,
      trainingDataModification: {} as TrainingDataModification,
      store: useStore<RootState>(),
    };
  },
  mounted() {
    this.refreshEntities();
  },
  methods: {
    async refreshEntities() {
      if (this.entities) {
        this.totalRows = this.entities.length;
      }

      if (this.entities && this.entities.length > 0 && this.totalRows) {
        this.container = this.entities[0]?.container.name;
        this.origin = this.entities[0].origin;

        this.data = [];
        let size = (this.currentPage - 1) * this.rowPerPage;

        const condition = (this.totalRows - (this.currentPage - 1) * this.rowPerPage) / 10;

        let skip;
        if (condition >= 1) {
          skip = size + this.rowPerPage;
        } else {
          skip = condition * 10 + size;
        }

        if (size <= this.entities.length) {
          for (let i = size; i < skip; i++) {
            if (this.entities[i].dateTime) {
              this.data.push(this.entities[i]);
            }
          }
        }
      } else {
        this.data.push();
      }
    },

    /**
     * set page
     * @param page
     */
    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.refreshEntities();
    },

    /**
     * change page
     * @param {number} page
     */
    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshEntities();
    },

    openEditModal(row: TrainingData) {
      this.editForm = { ...row };
      this.isModalVisible = true;
    },

    async saveChanges() {
      try {
        if (this.allParams) {
          const filter: Filter = {
            fields: {
              "trainingData.dateTime": { operator: "equal", value: this.editForm.dateTime },
              "trainingData.container": { operator: "equal", value: this.editForm.container.id },
              "trainingData.origin": { operator: "equal", value: this.editForm.origin },
            },
          };

          let trainingData = await getvisualizeTrainingData(
            undefined,
            undefined,
            filter,
            undefined
          );

          trainingData.data.forEach((element: { event: string | undefined }) => {
            element.event = this.editForm.event;
          });

          const combinedData = [this.editForm, ...trainingData.data];

          const user = await getUserById(this.store.state.auth.user?.id || 0);

          const seenIds = new Set<number>();

          const modifications = combinedData
            .filter((item) => {
              if (seenIds.has(item.id)) return false;
              seenIds.add(item.id);
              return true;
            })
            .map((item) => ({
              trainingDataId: item.id,
              userId: user.id,
            }));

          await postTrainingDataModification(modifications);
          await postTrainingData(combinedData);
        } else {
          await postTrainingData([this.editForm]);

          const user = await getUserById(this.store.state.auth.user?.id || 0);

          this.trainingDataModification = {
            trainingDataId: this.editForm.id,
            userId: user.id,
          };

          await postTrainingDataModification([this.trainingDataModification]);
        }

        this.isModalVisible = false;
        this.refreshEntities();
        ElMessage.success("Datos modificados con éxito");
      } catch (error) {
        ElMessage.error("Error al modificar los datos");
        console.error("Error guardando cambios:", error);
      }
    },
  },

  watch: {
    entities: {
      handler(val) {
        // - over property
        this.refreshEntities();
      },
      deep: false,
    },
  },
});
